/* eslint-disable import/prefer-default-export */
import { createSelector } from "reselect";

const permissionsState = (state) => state.permissions;

export const selectPermissions = createSelector(permissionsState, (permissions) => permissions.all.items);
